<template>
  <v-table
    :count="count"
    :list="list"
    :is-loading="isLoading"
    :push-list="RouteConfig.courseScheduleList.push"
    :query-list="queryList"
    :is-show-store-select="isAdministrator"
    :is-store-select-clearable="true"
    :is-hide-filter="!isAdministrator"
  >
    <el-table-column label="ID" prop="id"/>
    <v-column-time value="删除时间" field="is_del"/>
    <v-column-time value="修改时间" field="update_time" sortable=""/>
    <el-table-column label="课程表名称" prop="schedule_name"/>
    <el-table-column label="所属门店">
      <template v-slot="{ row }">
        <span class="user-select">{{ row.store_name }}</span>
      </template>
    </el-table-column>

    <v-column-avatar label="添加者"/>
    <el-table-column label="开始日期">
      <template v-slot="{ row }">
        {{ row.start_date | timeToYmd }}
      </template>
    </el-table-column>
    <el-table-column label="结束日期">
      <template v-slot="{ row }">
        {{ row.end_date | timeToYmd }}
      </template>
    </el-table-column>

    <el-table-column label="操作" width="300">
      <template v-slot="{ row }">

        <v-list-button icon="copy" name="复制" :to="RouteConfig.courseScheduleAdd.to('', { id: row.id })"/>
        <v-list-button :to="RouteConfig.courseScheduleEdit.to(row.id)"/>

        <v-popover>
          <v-popover-item
            icon="restore"
            name="恢复"
            @click="handleDelete(row)"
            :is-loading="isDeleting[row.id]"
            message="系统明日将依据此课表的有效期继续生成课程，确定要恢复此课表吗？"
          />
        </v-popover>
      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`card-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>添加者</span>

              <v-avatar-nickname
                :value="v.avatar"
                :nickname="v.nickname"
                :is-center="true"
                :nickname-overflow="true"
                :avatar-size="50"
                width="30vw"
              />
            </div>

            <div class="list-item-detail">
              <span>课表 ID</span>
              <span>{{ v.id }}</span>
            </div>

            <div class="list-item-detail">
              <span>删除时间</span>
              <span>{{ v.is_del | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>添加时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>修改时间</span>
              <span>{{ v.update_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>课表名称</span>
              <span>{{ v.schedule_name || '' }}</span>
            </div>
            <div class="list-item-detail">
              <span>所属门店</span>
              <span>{{ v.store_name || '' }}</span>
            </div>
            <div class="list-item-detail">
              <span>开始日期</span>
              <span>{{ v.start_date | timeToYmd }}</span>
            </div>
            <div class="list-item-detail">
              <span>结束日期</span>
              <span>{{ v.end_date | timeToYmd }}·</span>
            </div>
            <div class="list-item-button">
              <v-list-button icon="copy" name="复制" :to="RouteConfig.courseScheduleAdd.to('', { id: v.id })"/>
              <v-list-button :to="RouteConfig.courseScheduleEdit.to(v.id)"/>

              <v-popover>
                <v-popover-item
                  icon="restore"
                  name="恢复"
                  @click="handleDelete(v)"
                  :is-loading="isDeleting[v.id]"
                  message="系统明日将依据此课表的有效期继续生成课程，确定要恢复此课表吗？"
                />
              </v-popover>
            </div>
          </div>
        </template>

        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { index, restore } from '@/api/course-schedule';
import { getLegalQueryList } from '@/utils/formats';

export default {
  name: RouteConfig.courseScheduleDeletedList.name,
  data: () => ({
    RouteConfig,
    isLoading: false,
    isDeleting: {},
    isGenerating: {},
    queryList: {
      page: 1,
      size: 8,
      store_id: '',
      keyword: '',
      is_asc: 0,
    },
    count: 0,
    list: [],
    generateCourseDialog: {
      dates: [],
      isShow: false,
      id: 0,
    },
    rules: {
      dates: [{ required: true, message: '请选择日期范围',  trigger: 'change' }],
    },
  }),
  computed: {
    ...mapGetters([
      'isMobile',
      'isAdministrator',
      'isManager',
      'isReceptionist',
      'userStoreId',
    ]),
  },
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    refresh() {
      RouteConfig.courseScheduleDeletedList.push(this.queryList);
    },
    handleStoreChange() {
      this.queryList.page = 1;
      this.refresh();
    },
    handlePageChange({ page, size }) {
      this.queryList.page = page;
      this.queryList.size = size;
      this.refresh();
    },
    async load(route = this.$route) {
      if (this.isLoading) return;

      this.isLoading = true;
      const { queryList } = this;
      getLegalQueryList(queryList, route.query);
      queryList.is_del = 1;

      const { isError, data } = await index(queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
    },
    async handleDelete({ id, update_time }) {
      if (this.isDeleting[id]) return;
      if (!id) return this.$message.error('缺少课表标识信息，无法进行恢复！');
      if (!Number.isInteger(update_time) || update_time < 0) return this.$message.error('缺少课表信息，无法进行恢复！');

      this.$set(this.isDeleting, id, true);
      const { isError } = await restore(id, update_time);
      this.$set(this.isDeleting, id, false);
      if (!isError) this.load();
    },
  },
};
</script>
